import { h, render, Component } from 'preact';
import { checkRequiredInvalid, checkEmail } from '../utils/utils';
import TxrInput from './txr-input';
import { appConfig } from '../app.config';
import qs from 'qs';
import axios from 'axios';
import { HubspotService } from '../hubspot.service';

class TxrGatedContentForm extends Component {
    state = {
        isSubmitted: false,
        isValid: false,
        messageSent: false,
        isLoading: false,
        isError: false,
        errors: {
            required: 'Required field',
            email: 'Please enter a valid e-mail'
        },
        firstNameModel: {
            value: '',
            invalid: false,
            errors: {},
            change: (model) => {
                const hasError = checkRequiredInvalid(model, this.state.isSubmitted);
                model.invalid = hasError && this.state.isSubmitted;
                this.forceUpdate();
            }
        },
        lastNameModel: {
            value: '',
            invalid: false,
            errors: {},
            change: (model) => {
                const hasError = checkRequiredInvalid(model, this.state.isSubmitted);
                model.invalid = hasError && this.state.isSubmitted;
                this.forceUpdate();
            }
        },
        emailModel: {
            value: '',
            invalid: false,
            errors: {},
            change: (model) => {
                const hasError = checkRequiredInvalid(model, this.state.isSubmitted) || checkEmail(model, this.state.isSubmitted);
                model.invalid = hasError && this.state.isSubmitted;
                this.forceUpdate();
            }
        },
        companyModel: {
            value: '',
            invalid: false,
            errors: {},
            change: (model) => {
                const hasError = checkRequiredInvalid(model, this.state.isSubmitted);
                model.invalid = hasError && this.state.isSubmitted;
                this.forceUpdate();
            }
        },
    }
    sent = () => {
        this.state.isSubmitted = true;
        this.setState({isSubmitted: true});

        this.state.firstNameModel.change(this.state.firstNameModel);
        this.state.lastNameModel.change(this.state.lastNameModel);
        this.state.emailModel.change(this.state.emailModel);
        this.state.companyModel.change(this.state.companyModel);

        if (this.state.firstNameModel.invalid || this.state.lastNameModel.invalid || this.state.emailModel.invalid || this.state.companyModel.invalid) {
            return;
        }
        this.setState({isLoading: true, messageSent: true});

           const hubspot = new HubspotService();
        
            hubspot.submitFormV3([
                    {
                        name: "email",
                        value: this.state.emailModel.value
                    },
                    {
                        name: "firstname",
                        value: this.state.firstNameModel.value
                    },
                    {
                        name: "lastname",
                        value: this.state.lastNameModel.value
                    },
                    {
                        name: "company",
                        value: this.state.companyModel.value
                    },
                ], appConfig.hubspotFormSubmissionFormId)
            .then((response) => {
                if (response == true)
                    this.setState({isLoading: false, isError: false});
                else
                    this.setState({isLoading: false, isError: true});
            })
            .catch((err) => {
                this.setState({isLoading: false, isError: true});
            });
    }
    onSubmit = e => {
        return false;
      }
    render() {
        return (
            <div class="txr-gated-content-form">
            {!this.state.messageSent &&
                <form onsubmit={this.onSubmit} class="gated-content-form">
                     <div class="txr-form__item">
                         <TxrInput model={this.state.firstNameModel} type="text" label="First Name" errors={this.state.errors}> </TxrInput>
                     </div>
                     <div class="txr-form__item">
                         <TxrInput model={this.state.lastNameModel} type="text" label="Last Name" errors={this.state.errors}> </TxrInput>
                     </div>

                     <div class="txr-form__item">
                        <TxrInput model={this.state.emailModel} type="email" label="Your Email" errors={this.state.errors}></TxrInput>
                     </div>
                     <div class="txr-form__item">
                        <TxrInput model={this.state.companyModel} type="text" label="Company" errors={this.state.errors}></TxrInput>
                     </div>
                     <div class="txr-form__button">
                            <button class="txr-button txr-primary-button" disabled={(this.state.firstNameModel.invalid || this.state.lastNameModel.invalid || this.state.emailModel.invalid  || this.state.companyModel.invalid) && this.state.isSubmitted} type="button" onClick={() => this.sent()}>
                                <span class="txr-button__content"> DOWNLOAD NOW
                                    {!this.state.isLoading && <i class="txr-button__angle-icon fal fa-angle-right"></i>}
                                    {this.state.isLoading && <i class="fas fa-circle-notch fa-spin"></i>}
                                </span>
                            </button>
                      </div>

                </form>
            }
            {this.state.messageSent && !this.state.isError &&
            <div class="gated-content-complete">
                  <div class="complete__title">  
                  You got it! Check your inbox, it'll be there any moment now
                  </div>
                </div>
            }
            {this.state.messageSent && this.state.isError &&
            <div class="gated-content-complete error">
                  <div class="complete__title">  
                  Something went wrong! Please try again.
                  </div>
                </div>
            }            
            </div>
        )
    }
}

export default TxrGatedContentForm;